module.exports = __webpack_public_path__ + "static/img/5.f738e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital0/5.png
// module id = hjwO
// module chunks = 1